import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
const BEGINNER_REVIEW_NAMES = ['Alecia Williams', 'David Bushman', 'Gina Nguyen'];
export function DoSomeMartialArtsReviews() {
  const reviews = STORM_REVIEWS.filter(r => BEGINNER_REVIEW_NAMES.includes(r.name));
  return <section className="py-24 bg-off-white" data-id="element-981">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-982">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-983">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-984">
            Real Beginners. Real Reviews.
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-985">
            These are real Storm students who started exactly where you are
            today — no experience, just curiosity.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-986">
          {reviews.map(r => <ReviewCard key={r.name} quote={r.quote} name={r.name} label={r.label} data-id="element-987" />)}
        </div>
      </div>
    </section>;
}